export default __webpack_public_path__ + "static/media/emergency-call.44ae015f.svg";